module.exports = __webpack_public_path__ + "img/man-border.09482d6c.svg";